export default __webpack_public_path__ + "static/media/folklore.1db04656.png";